module.exports = __webpack_public_path__ + "img/logo__metaLearning__ch.cf760d6f.png";